import React from 'react';
import request from 'arcdynamic-request';
import {LENDERS} from '../../consts/tables';
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
import Input from "../Input-new/Input";
import { GET_LENDERS } from '../Graphql/Queries/LendersQuery';
import { ApolloConsumer } from '@apollo/client';
import { GET_CONTACT_LENDERS_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';
import { fetchData } from '../Service/graphQlService';

const cloneDeep = require('lodash.clonedeep');
const limit = 1000;

class SelectLender extends React.Component {
    constructor(props) {
        super(props);
        this.client = null;
        this.state = {
            items: [],
            lender: {},
        };

        this.getSelectedOption = this.getSelectedOption.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

        if(this.client ){
        this.fetch();
        }
    }

    fetch() {
        // request(arc.path.api, {
        //     service: 'arcimedes',
        //     action: 'open.datasource.table.Data.getData',
        //     params: ['code', LENDERS, {
        //         limit: {
        //             count: limit,
        //             offset: offset * limit,
        //         },
        //         column: [
        //             'ARCIMEDES_ROW_ID',
        //             'NAME',
        //             'CONTACT_NAME',
        //         ],
        //         filter: [{
        //             code: 'NAME',
        //             text: '',
        //             type: 'notNull',
        //         }, {
        //             code: 'DELETED',
        //             text: '',
        //             type: 'null',
        //         }],
        //         filterType: 'and',
        //         order: [{
        //             code: 'NAME',
        //             type: 'asc',
        //         }],
        //     }],
        var pageParams = {
            page: null,
            pageSize: null
        }
        let filters = [
            // {
            //   "deleted": null
            // }
          ]
          const sortOptions = [
            {
                "field": "name",
                "order": "asc"
              }
          ]
        // const token = localStorage.getItem('authToken');
        // this.client.query({
        //     query: GET_LENDERS, variables: { pageOptions: pageParams, filters: filters, sortOptions: sortOptions }, fetchPolicy: "no-cache",
        //     context: {
        //         headers: {
        //             authorization: `Bearer ${token}`, // Bearer token added here
        //         },
        //     }
        // })
        fetchData(GET_CONTACT_LENDERS_LIST_QUERY, {type: "Lender", pageOptions: pageParams, filters: filters, sortOptions: sortOptions })
        .then(res => {
            this.setState(prevState => {
                const data = res.data.getContacts.data;
                const items = prevState.items.concat(data);
                return {
                    items,
                };
            });
            // if (res.data.length >= limit) {
            //     this.fetch(++offset);
            // }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.newLender !== nextProps.newLender) {
            const items = cloneDeep(this.state.items);
            items.push(nextProps.newLender);
            this.setState({
                items,
                lender: nextProps.newLender,
            });
        }

        if (this.props.data.lender_id !== nextProps.data.lender_id) {
                // clear the lender contact when no lender is selected
                const option = this.state.items.find(item => item.lender_id === nextProps.data.lender_id) || {};
                this.setState({lender: option});
        }
    }

    getSelectedOption(option) {
        if (option && !Object.keys(this.state.lender).length)
            this.setState({lender: option});
    }

    handleChange(data, optionsType, value, valueKey, typeKey, option) {
        this.setState({lender: option || {}});
        this.props.handleParentChange(data, optionsType, value, valueKey, typeKey);
    }

    render() {
        const { items, lender } = this.state;
        const {
            theme,
            value,
            valueKey,
            label,
            disabled,
            data,
            withAddNew,
            isFilter,
            viewMode,
            addNewItem,
            deleted,
            isFromProperty,
            withContact,
            className,
            ...rest
        } = this.props;

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
            <React.Fragment>
                <Dropdown theme={theme}
                          className={className}
                          optionsType='lender'
                          optionKey='arcimedes_row_id' 
                          options={items}
                          value={value}
                          valueKey={valueKey}
                          label={label}
                          disabled={!items || disabled}
                          data={data}
                          isFilter={isFilter}
                          handleParentChange={this.handleChange}
                          withAddNew={withAddNew}
                          viewMode={viewMode}
                          deleted={deleted}
                          addNewItem={addNewItem}
                          isFromProperty={isFromProperty}
                          getSelectedOption={this.getSelectedOption}
                          {...rest}
                />
                {
                    withContact &&
                    <Input theme={theme}
                           className={className}
                           name='contact_name'
                           value={lender && lender.contact_name}
                           valueType="text"
                           label='Lender Contact'
                           disabled
                           viewMode={viewMode}
                           deleted={deleted}
                    />
                }
            </React.Fragment>
            )
        }}
    </ApolloConsumer>
        )
    }
}

SelectLender.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
    withContact: PropTypes.bool,
    className: PropTypes.string,
};

export default SelectLender;
